var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{staticClass:"v-data-table-cursor",attrs:{"promise":_vm.promise,"headers":_vm.headers,"itemsMenu":[5, 10, 15, 30, 50, 100],"selectedRow":true},on:{"options":_vm.onOptionsChange,"selectedRow":function($event){return _vm.selecionadoLead($event)}},scopedSlots:_vm._u([{key:"item.dataCadastro",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTime")(item.dataCadastro))+" ")]}},{key:"item.telefone",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-no-wrap"},[_vm._v(" "+_vm._s(_vm._f("telefone")(item.telefone))+" ")])]}},{key:"item.dataUltimoStatus",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTime")(item.dataUltimoStatus))+" ")]}},{key:"item.idEtapaLead",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("etapaLead")(item.idEtapaLead))+" ")]}},{key:"item.idStatusLead",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("statusLead")(item.idStatusLead))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }